import { Advisor } from 'types';
import React, { createContext, useContext, useMemo } from 'react';

export interface FocusingAdviserProfile {
  advisor: Advisor | undefined;
  isLoading: boolean | undefined;
  set: {
    advisor: (advisor: Advisor | undefined) => void;
    isLoading: (isLoading: boolean) => void;
  };
}

const INIT_STATE = {
  advisor: undefined,
  isLoading: undefined,
  set: {
    advisor: () => undefined,
    isLoading: () => undefined,
  },
};

export const FocusingAdviserProfileContext =
  createContext<FocusingAdviserProfile>(INIT_STATE);

function FocusingAdviserProfileProvider({
  children,
  advisor,
}: {
  children: React.ReactNode;
  advisor: Advisor | undefined;
}) {
  const [_state, setState] = React.useState<FocusingAdviserProfile>(INIT_STATE);
  return useMemo(() => {
    return (
      <FocusingAdviserProfileContext.Provider
        value={{
          advisor: _state.advisor || advisor,
          isLoading: _state.isLoading,
          set: {
            advisor: (nextAdvisor: Advisor | undefined) => {
              setState(prevState => ({
                ...prevState,
                advisor: nextAdvisor,
                isLoading: false,
              }));
            },
            isLoading: (isLoading: boolean) => {
              setState(prevState => ({
                ...prevState,
                isLoading: isLoading,
              }));
            },
          },
        }}
      >
        {children}
      </FocusingAdviserProfileContext.Provider>
    );
  }, [_state.advisor, _state.isLoading, advisor, children]);
}
export const useFocusingAdviserProfile = (): FocusingAdviserProfile =>
  useContext<FocusingAdviserProfile>(FocusingAdviserProfileContext);

export default FocusingAdviserProfileProvider;
